import { render, staticRenderFns } from "./ScoreBoard.vue?vue&type=template&id=685ce3b9&scoped=true"
import script from "./ScoreBoard.vue?vue&type=script&lang=js"
export * from "./ScoreBoard.vue?vue&type=script&lang=js"
import style0 from "./ScoreBoard.vue?vue&type=style&index=0&id=685ce3b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685ce3b9",
  null
  
)

export default component.exports